import { render, staticRenderFns } from "./changemobile.vue?vue&type=template&id=c63276d8&scoped=true&"
import script from "./changemobile.vue?vue&type=script&lang=js&"
export * from "./changemobile.vue?vue&type=script&lang=js&"
import style0 from "./changemobile.vue?vue&type=style&index=0&id=c63276d8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63276d8",
  null
  
)

export default component.exports